<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': notes }" data-toggle="tab" href="#pills-notes"  (click)="ver('notes')">
                        <span class="nav-text">Notes</span>
                    </a>
                </li>
                <li class="nav-item" >
                    <a class="nav-link" [ngClass]="{ 'active': recall }" id="pills-recall-tab" data-toggle="tab"
                        data-bs-target="#pills-recall" href="#pills-recall"  
                        (click)="ver('recall')">
                        Recall
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade" [ngClass]="{ 'show active': notes }" id="pills-notes" role="tabpanel"
        aria-labelledby="pills-notes-tab">
        <ngx-work-notes [pet_no]="pet_no"></ngx-work-notes>
    </div>
    <div class="tab-pane fade" [ngClass]="{ 'show active': recall }" id="pills-recall" role="tabpanel"
        aria-labelledby="pills-recall-tab">
        <ngx-work-recall [pet_no]="pet_no"></ngx-work-recall>
    </div>
</div>